import { bimWorkOrderChapterLabel } from '../../types';

type TMaybe<T> = T | null | undefined;

export const chapterFormatter = <T extends { chapter?: TMaybe<keyof typeof bimWorkOrderChapterLabel> }>({
    data,
}: {
    data: TMaybe<T>;
}) => (data?.chapter ? bimWorkOrderChapterLabel[data?.chapter] : '');
